module.exports = __webpack_public_path__ + "assets/icons/ic_search-e930.svg";